document.addEventListener('DOMContentLoaded', function () {

  // ── EmailJS config — replace these three values ──
  var EMAILJS_PUBLIC_KEY  = 'cOUBx44ouR9SEucox';
  var EMAILJS_SERVICE_ID  = 'service_sd7safd';
  var EMAILJS_TEMPLATE_ID = 'template_pcghvgt';

  emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });

  // ── Current year ──
  var yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  // ── Accordion ──
  document.querySelectorAll('.accordion-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = btn.closest('.accordion-item');
      var isOpen = item.classList.contains('open');

      // Close all (single-open behaviour)
      document.querySelectorAll('.accordion-item').forEach(function (el) {
        el.classList.remove('open');
        el.querySelector('.accordion-toggle').setAttribute('aria-expanded', 'false');
      });

      // Open this one if it was closed
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── Mailing list form ──
  var mailingForm = document.getElementById('mailing-form');
  if (mailingForm) {
    mailingForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var form = e.currentTarget;
      var btn  = document.getElementById('submit-btn');

      btn.disabled    = true;
      btn.textContent = 'Subscribing...';

      emailjs.sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, form)
        .then(function () {
          btn.disabled    = false;
          btn.textContent = 'Subscribe';
          form.reset();
          showToast('Subscribed!', 'Thanks for signing up — we\'ll be in touch.');
        })
        .catch(function (error) {
          console.error('EmailJS error:', error);
          btn.disabled    = false;
          btn.textContent = 'Subscribe';
          showToast('Something went wrong.', 'Please try again or email us directly.');
        });
    });
  }

  // ── Toast ──
  function showToast(title, desc) {
    var toast     = document.getElementById('toast');
    var toastTitle = toast.querySelector('.toast-title');
    var toastDesc  = toast.querySelector('.toast-desc');
    if (toastTitle) toastTitle.textContent = title;
    if (toastDesc)  toastDesc.textContent  = desc;
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 5000);
  }

});